import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { removeItem, } from '@tymia/shared';
import { useDeferredValue, useEffect, useState, } from 'react';
import { ArrowDropDownIcon, } from '../icons/ArrowDropDownIcon.js';
import { ArrowDropUpIcon, } from '../icons/ArrowDropUpIcon.js';
const selectedValues = {};
const listeners = {};
function toggleSelectedValue(group, value) {
    setSelectedValue(group, selectedValues[group] === value ? null : value);
}
function setSelectedValue(group, value) {
    selectedValues[group] = value;
    listeners[group]?.forEach(listener => listener(value));
}
function subscribe(group, listener) {
    const list = listeners[group] ?? [];
    listeners[group] = list;
    list.push(listener);
    listener(selectedValues[group] ?? null);
    return () => removeItem(list, listener);
}
export function FilterItemGroup({ group, label, labelClass, children }) {
    const [checked, setChecked] = useState(false);
    // the child component is removed too fast, so no callbacks are fired.
    // Therefore, delay the removal of the child component
    const checkedDeferred = useDeferredValue(checked);
    useEffect(() => {
        const unsubscribe = subscribe(group, value => setChecked(value === label));
        return unsubscribe;
    }, [label]);
    function close() {
        setSelectedValue(group, null);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "inline-block", onClick: () => toggleSelectedValue(group, label), children: _jsxs("label", { className: labelClass, children: [label, checked
                            ? _jsx(ArrowDropUpIcon, { size: 24, className: "fill-tym-green" })
                            : _jsx(ArrowDropDownIcon, { size: 24, className: "fill-tym-green" })] }) }), checkedDeferred && (_jsx("div", { className: "filterpoints content", children: children({ close }) }))] }));
}
//# sourceMappingURL=FilterItemGroup.js.map